<template>
  <vs-row class="p-1" vs-border="1px">
    <vs-col vs-lg="2" vs-sm="3">
      <b-img-lazy
        :src="product.imageUrl"
        :alt="product.title"
        center
        fluid-grow
      />
    </vs-col>
    <vs-col vs-lg="8" vs-sm="7" class="p-1">
      <vs-row>
        {{ $t('catalog.productList.product.id') }}&nbsp;{{ product.id }}
      </vs-row>
      <vs-row>
        {{ $t('catalog.productList.product.title') }}&nbsp;
        <a :href="product.productUrl" target="_blank">
          {{ product.title }}
        </a>
      </vs-row>
      <vs-row>
        {{ $t('catalog.productList.product.categories') }}  {{ product.categories.join(' / ') }}
      </vs-row>
    </vs-col>
    <vs-col vs-lg="2" vs-sm="2">
        <vs-button class="w-100 mt-1" @click="detachItem(product.id)">
          {{ $t('socialStream.productList.detach') }}
        </vs-button>
    </vs-col>
  </vs-row>
</template>

<script>
import { defineComponent, PropType } from '@vue/composition-api'
import { Trash2Icon } from 'vue-feather-icons'
import store from '@/store'
import QonStaticImage from '@/libs/QonStaticImage'
import DefaultProductsStore from '@/store/socialStream/socialStreamDefaultProducts'

export default defineComponent({
  name: 'DefaultProductRow',
  components: {
    Trash2Icon,
  },
  props: {
    product: {
      type: Object,
      default() {
        return {
          id: '',
          title: '',
          link: '',
          imageLink: '',
        }
      },
    },
  },
  computed: {
  },
  methods: {
    generateQonLink(url) {
      const { customerSymbol } = store.state.user.appActiveUser
      return QonStaticImage.generateQonLink(customerSymbol, url, 251, null)
    },
    setAlternativeImage(event) {
      QonStaticImage.setAlternativeImage(event)
    },
    detachItem(itemId) {
      DefaultProductsStore.dispatch('removeDefaultProduct', itemId)
    },
  },
})
</script>


